var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_7378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7563 4.58983C14.0144 3.33177 15.7207 2.625 17.4998 2.625H20.9998C21.4831 2.625 21.8748 3.01675 21.8748 3.5V8.16667C21.8748 8.64992 21.4831 9.04167 20.9998 9.04167H17.4998C17.4225 9.04167 17.3483 9.0724 17.2936 9.12709C17.2389 9.18179 17.2082 9.25598 17.2082 9.33333V10.7917H20.9998C21.2693 10.7917 21.5237 10.9158 21.6895 11.1282C21.8553 11.3406 21.9141 11.6175 21.8487 11.8789L20.682 16.5456C20.5847 16.9351 20.2347 17.2083 19.8332 17.2083H17.2082V24.5C17.2082 24.9832 16.8164 25.375 16.3332 25.375H11.6665C11.1833 25.375 10.7915 24.9832 10.7915 24.5V17.2083H8.1665C7.68325 17.2083 7.2915 16.8166 7.2915 16.3333V11.6667C7.2915 11.1834 7.68325 10.7917 8.1665 10.7917H10.7915V9.33333C10.7915 7.55417 11.4983 5.84788 12.7563 4.58983ZM17.4998 4.375C16.1848 4.375 14.9236 4.89739 13.9938 5.82726C13.0639 6.75713 12.5415 8.0183 12.5415 9.33333V11.6667C12.5415 12.1499 12.1498 12.5417 11.6665 12.5417H9.0415V15.4583H11.6665C12.1498 15.4583 12.5415 15.8501 12.5415 16.3333V23.625H15.4582V16.3333C15.4582 15.8501 15.8499 15.4583 16.3332 15.4583H19.15L19.8792 12.5417H16.3332C15.8499 12.5417 15.4582 12.1499 15.4582 11.6667V9.33333C15.4582 8.79185 15.6733 8.27254 16.0562 7.88966C16.439 7.50677 16.9584 7.29167 17.4998 7.29167H20.1248V4.375H17.4998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_7378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b8171f52e41043f4ef67025e4e26753f.svg";
export { ForwardRef as ReactComponent };